var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuilarComplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 174,
    height: 226,
    viewBox: "0 0 174 226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Logo_builar",
    "data-name": "Logo builar",
    width: 174,
    height: 226,
    transform: "translate(120 3935)",
    fill: "#d5d5d5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_3",
    "data-name": "Enmascarar grupo 3",
    transform: "translate(-120 -3935)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2",
    transform: "translate(120 3947.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M59.8,19.76V53.5a29.473,29.473,0,0,1-58.945,0V19.76H18.341V53.5a11.986,11.986,0,1,0,23.971,0V19.76Z",
    fill: "#171c8f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_13",
    "data-name": "Rect\\xE1ngulo 13",
    width: 58.945,
    height: 9.576,
    transform: "translate(0.854 89.247)",
    fill: "#ee5340"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_14",
    "data-name": "Rect\\xE1ngulo 14",
    width: 58.945,
    height: 9.576,
    transform: "translate(0.854)",
    fill: "#ee5340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M30.882,136.13a15.488,15.488,0,0,1,6.057,6.484,22.57,22.57,0,0,1,0,19.2,15.608,15.608,0,0,1-5.98,6.5,16.992,16.992,0,0,1-8.8,2.281,16.863,16.863,0,0,1-7.185-1.512,11.857,11.857,0,0,1-5.032-4.143l-.607,4.639H1.358V116.618h9.568v21.528a11.4,11.4,0,0,1,4.656-3.169,17.8,17.8,0,0,1,6.467-1.111,17.162,17.162,0,0,1,8.833,2.264Zm-4.1,23.066a11.106,11.106,0,0,0,0-14.061,8.637,8.637,0,0,0-6.621-2.7,8.62,8.62,0,0,0-6.6,2.657,9.952,9.952,0,0,0-2.46,7.039,9.764,9.764,0,0,0,2.563,7.065,8.791,8.791,0,0,0,6.646,2.657,8.543,8.543,0,0,0,6.467-2.691Z",
    fill: "#171c8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M80.55,127.16a6.176,6.176,0,0,1,0-8.876,6.467,6.467,0,0,1,4.673-1.811,6.267,6.267,0,1,1,0,12.524A6.476,6.476,0,0,1,80.55,127.16Zm-.111,7.817h9.576v34.607H80.439Z",
    fill: "#171c8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12",
    "data-name": "Trazado 12",
    d: "M95.859,116.618h9.653v52.965H95.859Z",
    fill: "#171c8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M147.158,134.976v34.607h-9.192v-4.417a12.208,12.208,0,0,1-5.015,3.964,17.086,17.086,0,0,1-7.091,1.469,16.138,16.138,0,0,1-8.543-2.247,15.377,15.377,0,0,1-5.783-6.33,20.767,20.767,0,0,1-2.076-9.517,21.306,21.306,0,0,1,2.153-9.782,15.608,15.608,0,0,1,6.091-6.561,18.581,18.581,0,0,1,15.8-1.017,11.9,11.9,0,0,1,4.9,3.784l.837-3.955ZM134.976,159.2a11.106,11.106,0,0,0,0-14.138,8.662,8.662,0,0,0-6.612-2.657,8.543,8.543,0,0,0-6.638,2.7,10.055,10.055,0,0,0-2.443,7.031,9.91,9.91,0,0,0,2.5,7.031,8.483,8.483,0,0,0,6.5,2.691,8.808,8.808,0,0,0,6.689-2.657Z",
    fill: "#171c8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M174,134.976v8.3a16,16,0,0,0-1.845-.077q-4.639,0-7.108,2.5a9.74,9.74,0,0,0-2.469,7.073v16.812h-9.662V134.976h8.705l.794,4.98a6.578,6.578,0,0,1,3.033-4,10.251,10.251,0,0,1,5.373-1.358A10.738,10.738,0,0,1,174,134.976Z",
    fill: "#171c8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M74.818,134.976v18.47a16.133,16.133,0,0,1-32.266,0v-18.47h9.559v18.47a6.561,6.561,0,0,0,13.122,0v-18.47Z",
    fill: "#171c8f"
  }), /*#__PURE__*/React.createElement("text", {
    id: "built_easy_for_you_",
    "data-name": "built easy for you!",
    transform: "translate(0 196.143)",
    fill: "#171c8f",
    fontSize: 19,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "built ea"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.01em"
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "y "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.01em"
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "or "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.02em"
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ou!")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilarComplete);
export default __webpack_public_path__ + "static/media/builar-complete.77d1c6b579864b2e9e20bd91cff8e3ee.svg";
export { ForwardRef as ReactComponent };